    <app-header></app-header>
    
    <main class="container mx-auto px-4 pb-6 lg:px-6 lg:py-8">
        <!-- Hero Section -->
        <section class="mt-4 mb-8 lg:mb-12">
            <div class="bg-gradient-to-r from-wattpad-primary to-wattpad-secondary rounded-xl p-6 lg:p-8 text-white">
                <div class="flex flex-col lg:flex-row gap-6 items-center">
                    <div class="lg:w-1/3 flex justify-center">
                        <div class="bg-white/20 p-6 rounded-full w-48 h-48 flex items-center justify-center animate-float">
                            <i class="fas fa-book-open text-6xl"></i>
                        </div>
                    </div>
                    <div class="lg:w-2/3 text-center lg:text-left">
                        <h1 class="text-2xl lg:text-4xl font-bold mb-2">📚 Products & Services — Funtel Stories</h1>
                        <p class="text-xl lg:text-2xl mb-4 font-medium">Discover a world of immersive storytelling</p>
                        
                        <p class="text-sm lg:text-base mb-6">
                            Funtel Stories brings together readers, listeners, and creators to explore diverse stories 
                            through our rich collection of web-novels, audio stories, and premium episodes. 
                            Experience storytelling anytime, anywhere.
                        </p>
                        
                        <div class="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                            <a href="#services" class="bg-white text-wattpad-primary px-8 py-3 rounded-full font-bold hover:bg-gray-100 transition-colors text-lg">
                                Explore Services
                            </a>
                            <a href="#categories" class="bg-white/20 text-white px-8 py-3 rounded-full font-medium hover:bg-white/30 transition-colors text-lg">
                                Browse Categories
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Services Grid -->
        <section class="mb-8 lg:mb-12" id="services">
            <h2 class="text-2xl lg:text-3xl font-bold mb-6 text-center gradient-text">Our Products & Services</h2>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Webnovels & Story Episodes -->
                <div class="service-card bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-700">
                    <div class="flex items-start mb-4">
                        <div class="bg-wattpad-primary/10 p-3 rounded-lg mr-4">
                            <i class="fas fa-book text-wattpad-primary text-xl"></i>
                        </div>
                        <div>
                            <h3 class="font-bold text-lg mb-1 text-wattpad-primary">1. Webnovels & Story Episodes</h3>
                            <p class="text-gray-600 dark:text-gray-400 text-sm">
                                Explore beautifully crafted stories across multiple genres
                            </p>
                        </div>
                    </div>
                    
                    <div class="mb-4">
                        <div class="flex flex-wrap mb-3">
                            <span class="category-tag">Horror</span>
                            <span class="category-tag">Thriller</span>
                            <span class="category-tag">Romance</span>
                            <span class="category-tag">Fantasy</span>
                            <span class="category-tag">Paranormal</span>
                            <span class="category-tag">Mythology</span>
                            <span class="category-tag">Crime</span>
                            <span class="category-tag">Drama</span>
                        </div>
                        <p class="text-sm text-gray-600 dark:text-gray-400 mb-2">
                            Stories are published in episodic format — easy to read, binge, and follow.
                        </p>
                    </div>
                    
                    <div class="bg-gray-50 dark:bg-gray-700/50 p-3 rounded-lg">
                        <p class="text-sm font-medium flex items-center">
                            <i class="fas fa-info-circle text-wattpad-primary mr-2"></i>
                            <span class="text-wattpad-dark dark:text-gray-300">Access Type:</span>
                            <span class="ml-2 text-green-600">✅ Free Episodes</span>
                            <span class="mx-1">·</span>
                            <span class="text-wattpad-primary">✅ Premium Episodes</span>
                        </p>
                    </div>
                </div>

                <!-- Audio Stories -->
                <div class="service-card bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-700">
                    <div class="flex items-start mb-4">
                        <div class="bg-wattpad-accent/10 p-3 rounded-lg mr-4">
                            <i class="fas fa-headphones text-wattpad-accent text-xl"></i>
                        </div>
                        <div>
                            <h3 class="font-bold text-lg mb-1 text-wattpad-accent">2. Audio Stories (Voice-Narrated)</h3>
                            <p class="text-gray-600 dark:text-gray-400 text-sm">
                                Immerse yourself in cinematic storytelling
                            </p>
                        </div>
                    </div>
                    
                    <ul class="feature-list mb-4">
                        <li>Professional voice-over narrations</li>
                        <li>Background score & atmospheric sound design</li>
                        <li>Storytelling in Hindi & English</li>
                        <li>Expressive narrators</li>
                    </ul>
                    
                    <div class="bg-gray-50 dark:bg-gray-700/50 p-3 rounded-lg">
                        <p class="text-sm font-medium flex items-center">
                            <i class="fas fa-info-circle text-wattpad-accent mr-2"></i>
                            <span class="text-wattpad-dark dark:text-gray-300">Access Type:</span>
                            <span class="ml-2 text-green-600">✅ Free</span>
                            <span class="mx-1">·</span>
                            <span class="text-wattpad-accent">✅ Premium</span>
                        </p>
                    </div>
                </div>

                <!-- Premium Episode Unlock -->
                <div class="service-card bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-700">
                    <div class="flex items-start mb-4">
                        <div class="bg-wattpad-secondary/10 p-3 rounded-lg mr-4">
                            <i class="fas fa-lock-open text-wattpad-secondary text-xl"></i>
                        </div>
                        <div>
                            <h3 class="font-bold text-lg mb-1 text-wattpad-secondary">3. Premium Episode Unlock</h3>
                            <p class="text-gray-600 dark:text-gray-400 text-sm">
                                Unlock complete story series
                            </p>
                        </div>
                    </div>
                    
                    <div class="mb-4">
                        <p class="text-sm text-gray-600 dark:text-gray-400 mb-3">
                            Enjoy ad-free & uninterrupted engagement using:
                        </p>
                        <div class="flex items-center mb-2">
                            <i class="fas fa-coins text-yellow-500 mr-2"></i>
                            <span>Coins / credits</span>
                        </div>
                        <div class="flex items-center">
                            <i class="fas fa-crown text-wattpad-accent mr-2"></i>
                            <span>Subscription plans</span>
                        </div>
                    </div>
                    
                    <div class="bg-gray-50 dark:bg-gray-700/50 p-3 rounded-lg">
                        <p class="text-sm font-medium text-wattpad-secondary">
                            <i class="fas fa-star mr-2"></i>
                            Recommended for binge readers & listeners
                        </p>
                    </div>
                </div>

                <!-- Subscription Plans -->
                <div class="service-card bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-700">
                    <div class="flex items-start mb-4">
                        <div class="bg-wattpad-primary/10 p-3 rounded-lg mr-4">
                            <i class="fas fa-crown text-wattpad-primary text-xl"></i>
                        </div>
                        <div>
                            <h3 class="font-bold text-lg mb-1 text-wattpad-primary">4. Subscription Plans</h3>
                            <p class="text-gray-600 dark:text-gray-400 text-sm">
                                Get full access to premium content
                            </p>
                        </div>
                    </div>
                    
                    <ul class="feature-list mb-4">
                        <li>Monthly & Annual subscription options</li>
                        <li>Early access to new episodes</li>
                        <li>Exclusive creator stories</li>
                        <li>Ad-free experience</li>
                    </ul>
                    
                    <div class="bg-gray-50 dark:bg-gray-700/50 p-3 rounded-lg">
                        <p class="text-sm font-medium text-wattpad-primary">
                            <i class="fas fa-gift mr-2"></i>
                            More benefits coming soon
                        </p>
                    </div>
                </div>

                <!-- Creator Publishing -->
                <div class="service-card bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-700">
                    <div class="flex items-start mb-4">
                        <div class="bg-wattpad-accent/10 p-3 rounded-lg mr-4">
                            <i class="fas fa-pen-fancy text-wattpad-accent text-xl"></i>
                        </div>
                        <div>
                            <h3 class="font-bold text-lg mb-1 text-wattpad-accent">5. Creator Publishing</h3>
                            <p class="text-gray-600 dark:text-gray-400 text-sm">
                                Are you a writer or storyteller?
                            </p>
                        </div>
                    </div>
                    
                    <p class="text-sm text-gray-600 dark:text-gray-400 mb-3">
                        Publish your stories on Funtel Stories and grow your audience.
                    </p>
                    
                    <ul class="feature-list mb-4">
                        <li>Publish episodic stories</li>
                        <li>Earn from premium episodes</li>
                        <li>Build readership</li>
                        <li>Get featured on homepage</li>
                    </ul>
                    
                    <div class="bg-gray-50 dark:bg-gray-700/50 p-3 rounded-lg">
                        <p class="text-sm font-medium text-wattpad-accent">
                            <i class="fas fa-user-check mr-2"></i>
                            Eligible for registered creator accounts only
                        </p>
                    </div>
                </div>

                <!-- Funtel Coins / Credits -->
                <div class="service-card bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-700">
                    <div class="flex items-start mb-4">
                        <div class="bg-wattpad-secondary/10 p-3 rounded-lg mr-4">
                            <i class="fas fa-coins text-wattpad-secondary text-xl"></i>
                        </div>
                        <div>
                            <h3 class="font-bold text-lg mb-1 text-wattpad-secondary">6. Funtel Coins / Credits</h3>
                            <p class="text-gray-600 dark:text-gray-400 text-sm">
                                Buy coins and unlock premium episodes instantly
                            </p>
                        </div>
                    </div>
                    
                    <ul class="feature-list mb-4">
                        <li>Secure payment options</li>
                        <li>Flexible top-ups</li>
                        <li>Instant credit availability</li>
                    </ul>
                    
                    <div class="bg-gray-50 dark:bg-gray-700/50 p-3 rounded-lg">
                        <p class="text-sm font-medium text-wattpad-secondary">
                            <i class="fas fa-digital-tachograph mr-2"></i>
                            Digital currency used only inside Funtel ecosystem
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Categories Table -->
        <section class="mb-8 lg:mb-12" id="categories">
            <div class="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
                <h2 class="text-xl lg:text-2xl font-bold mb-6 text-wattpad-primary">7. Categories We Offer</h2>
                
                <div class="overflow-x-auto">
                    <table class="w-full border-collapse">
                        <thead>
                            <tr class="bg-wattpad-primary/10">
                                <th class="p-3 text-left font-bold text-wattpad-primary">Category</th>
                                <th class="p-3 text-left font-bold text-wattpad-primary">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                <td class="p-3 font-medium">Horror</td>
                                <td class="p-3 text-gray-600 dark:text-gray-400">Dark, supernatural, psychological</td>
                            </tr>
                            <tr class="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                <td class="p-3 font-medium">Thriller</td>
                                <td class="p-3 text-gray-600 dark:text-gray-400">Fast-paced, suspenseful</td>
                            </tr>
                            <tr class="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                <td class="p-3 font-medium">Romance</td>
                                <td class="p-3 text-gray-600 dark:text-gray-400">Emotions, relationships</td>
                            </tr>
                            <tr class="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                <td class="p-3 font-medium">Fantasy</td>
                                <td class="p-3 text-gray-600 dark:text-gray-400">Magical worlds & adventures</td>
                            </tr>
                            <tr class="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                <td class="p-3 font-medium">Paranormal</td>
                                <td class="p-3 text-gray-600 dark:text-gray-400">Spirits, afterlife, curses</td>
                            </tr>
                            <tr class="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                <td class="p-3 font-medium">Mythology</td>
                                <td class="p-3 text-gray-600 dark:text-gray-400">Gods, legends, ancient tales</td>
                            </tr>
                            <tr class="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                <td class="p-3 font-medium">Crime</td>
                                <td class="p-3 text-gray-600 dark:text-gray-400">Detectives, murders, mysteries</td>
                            </tr>
                            <tr class="hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                <td class="p-3 font-medium">Drama</td>
                                <td class="p-3 text-gray-600 dark:text-gray-400">Human emotions, real-life stories</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>

        <!-- Upcoming Feature -->
        <section class="mb-8 lg:mb-12">
            <div class="bg-gradient-to-r from-wattpad-accent to-orange-500 rounded-xl p-6 lg:p-8 text-white">
                <div class="flex flex-col lg:flex-row gap-6 items-center">
                    <div class="lg:w-1/3 flex justify-center">
                        <div class="bg-white/20 p-6 rounded-full w-48 h-48 flex items-center justify-center">
                            <i class="fas fa-film text-6xl"></i>
                        </div>
                    </div>
                    <div class="lg:w-2/3 text-center lg:text-left">
                        <h2 class="text-xl lg:text-3xl font-bold mb-2">🎬 Upcoming — Animated Visual Stories</h2>
                        <p class="text-lg lg:text-xl mb-4">We are building a next-gen visual storytelling experience</p>
                        
                        <p class="text-sm lg:text-base mb-6">
                            Combining animation, audio narration, and atmospheric design for an immersive experience like never before.
                        </p>
                        
                        <div class="flex items-center justify-center lg:justify-start">
                            <span class="bg-white/20 px-4 py-2 rounded-full font-medium animate-pulse">
                                Coming soon to Funtel Stories
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Why Choose Us & How to Access -->
        <section class="mb-8 lg:mb-12">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <!-- Why Choose Us -->
                <div class="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
                    <h2 class="text-xl lg:text-2xl font-bold mb-6 text-wattpad-primary">Why Choose Funtel Stories?</h2>
                    
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="flex items-start">
                            <i class="fas fa-check text-green-500 mt-1 mr-3"></i>
                            <div>
                                <h3 class="font-medium">Wide genre selection</h3>
                                <p class="text-sm text-gray-600 dark:text-gray-400">Something for every mood</p>
                            </div>
                        </div>
                        <div class="flex items-start">
                            <i class="fas fa-check text-green-500 mt-1 mr-3"></i>
                            <div>
                                <h3 class="font-medium">High-quality narration</h3>
                                <p class="text-sm text-gray-600 dark:text-gray-400">Professional voice artists</p>
                            </div>
                        </div>
                        <div class="flex items-start">
                            <i class="fas fa-check text-green-500 mt-1 mr-3"></i>
                            <div>
                                <h3 class="font-medium">Affordable premium content</h3>
                                <p class="text-sm text-gray-600 dark:text-gray-400">Great value for money</p>
                            </div>
                        </div>
                        <div class="flex items-start">
                            <i class="fas fa-check text-green-500 mt-1 mr-3"></i>
                            <div>
                                <h3 class="font-medium">Read + Listen anywhere</h3>
                                <p class="text-sm text-gray-600 dark:text-gray-400">Multi-format experience</p>
                            </div>
                        </div>
                        <div class="flex items-start">
                            <i class="fas fa-check text-green-500 mt-1 mr-3"></i>
                            <div>
                                <h3 class="font-medium">Best platform for new writers</h3>
                                <p class="text-sm text-gray-600 dark:text-gray-400">Creator-friendly ecosystem</p>
                            </div>
                        </div>
                        <div class="flex items-start">
                            <i class="fas fa-check text-green-500 mt-1 mr-3"></i>
                            <div>
                                <h3 class="font-medium">Trust & transparency</h3>
                                <p class="text-sm text-gray-600 dark:text-gray-400">Secure and reliable</p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- How to Access -->
                <div class="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
                    <h2 class="text-xl lg:text-2xl font-bold mb-6 text-wattpad-primary">How to Access</h2>
                    
                    <div class="space-y-4">
                        <div class="flex items-start">
                            <div class="bg-wattpad-primary/10 text-wattpad-primary rounded-full w-8 h-8 flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                                <span class="font-bold">1</span>
                            </div>
                            <div>
                                <h3 class="font-medium">Download the app</h3>
                                <p class="text-sm text-gray-600 dark:text-gray-400">Available on Android & iOS</p>
                            </div>
                        </div>
                        
                        <div class="flex items-start">
                            <div class="bg-wattpad-primary/10 text-wattpad-primary rounded-full w-8 h-8 flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                                <span class="font-bold">2</span>
                            </div>
                            <div>
                                <h3 class="font-medium">Register / login</h3>
                                <p class="text-sm text-gray-600 dark:text-gray-400">Create your account</p>
                            </div>
                        </div>
                        
                        <div class="flex items-start">
                            <div class="bg-wattpad-primary/10 text-wattpad-primary rounded-full w-8 h-8 flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                                <span class="font-bold">3</span>
                            </div>
                            <div>
                                <h3 class="font-medium">Browse stories</h3>
                                <p class="text-sm text-gray-600 dark:text-gray-400">Explore by genre or category</p>
                            </div>
                        </div>
                        
                        <div class="flex items-start">
                            <div class="bg-wattpad-primary/10 text-wattpad-primary rounded-full w-8 h-8 flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                                <span class="font-bold">4</span>
                            </div>
                            <div>
                                <h3 class="font-medium">Read or listen instantly</h3>
                                <p class="text-sm text-gray-600 dark:text-gray-400">Enjoy free content</p>
                            </div>
                        </div>
                        
                        <div class="flex items-start">
                            <div class="bg-wattpad-primary/10 text-wattpad-primary rounded-full w-8 h-8 flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                                <span class="font-bold">5</span>
                            </div>
                            <div>
                                <h3 class="font-medium">Unlock premium episodes</h3>
                                <p class="text-sm text-gray-600 dark:text-gray-400">With coins or subscription</p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="mt-6 flex flex-col sm:flex-row gap-4">
                        <a href="#" class="bg-wattpad-primary text-white py-3 px-6 rounded-lg font-bold text-center hover:bg-blue-600 transition-colors">
                            <i class="fab fa-google-play mr-2"></i> Google Play
                        </a>
                        <a href="#" class="bg-wattpad-secondary text-white py-3 px-6 rounded-lg font-bold text-center hover:bg-gray-700 transition-colors">
                            <i class="fab fa-apple mr-2"></i> App Store
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </main>
